export const authKeys = {
  account: (params: Record<string, number | string | undefined>) => [
    ...authKeys.base,
    "account",
    params,
  ],
  base: ["cosmos_auth"],
};
